<template lang="html">
<div class="card mb-3">
    <div class="card-header border-0 pb-0">
        <ul class="nav nav-tabs nav-tabs-line card-header-tabs"
            role="tablist">
            <li class="nav-item w-33 text-center"
                role="presentation">
                <a class="nav-link pt-3 active text-uppercase"
                   data-bs-toggle="tab"
                   href="#day"
                   role="tab"
                   aria-selected="true">Ce jour</a>
            </li>
            <li class="nav-item w-33 text-center"
                role="presentation">
                <a class="nav-link pt-3 text-uppercase"
                   id="s-days-tab"
                   data-bs-toggle="tab"
                   href="#s-days"
                   role="tab"
                   aria-selected="false">Depuis 7 jours</a>
            </li>
            <li class="nav-item w-33 text-center"
                role="presentation">
                <a class="nav-link pt-3 text-uppercase"
                   id="t-days-tab"
                   data-bs-toggle="tab"
                   href="#t-days"
                   role="tab"
                   aria-selected="false">Depuis 30 jours</a>
            </li>
        </ul>
    </div>
    <div class="card-body" v-if="stats">
        <div class="tab-content">
            <div class="tab-pane fade active show h-100 scroll-out" id="day" role="tabpanel">
                <div class="row g-2" >
                    <div class="col-4">
                        <div class="h-100 row g-0 align-items-center">
                            <div class="col-auto">
                                <div class="confetti bg-success sw-5 sh-5 rounded-md d-flex justify-content-center align-items-center">
                                    <i class="icon-20 bi-inbox text-white lh-1"></i>
                                </div>
                            </div>
                            <div class="col sh-6 ps-2 d-flex flex-column justify-content-center">
                                <div class="row g-0">
                                    <div class="col-auto">
                                        <div class="cta-4 text-primary">
                                            {{ clt_stat.today_recived_count }}  avis
                                        </div>
                                        <div class="text-muted small">Reçus</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="h-100 row g-0 align-items-center">
                            <div class="col-auto">
                                <div class="bg-alternate sw-5 sh-5 rounded-md d-flex justify-content-center align-items-center">
                                    <i class="icon-20 bi-x-octagon text-white lh-1"></i>
                                </div>
                            </div>
                            <div class="col sh-6 ps-2 d-flex flex-column justify-content-center">
                                <div class="row g-0">
                                    <div class="col-auto">
                                        <div class="cta-4 text-primary">
                                            {{clt_stat.today_impossible_count}} avis
                                        </div>
                                        <div class="text-muted small">Impossible</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="h-100 row g-0 align-items-center">
                            <div class="col-auto">
                                <div class="bg-info sw-5 sh-5 rounded-md d-flex justify-content-center align-items-center">
                                    <i class="icon-20 bi-pencil text-white lh-1"></i>
                                </div>
                            </div>
                            <div class="col sh-6 ps-2 d-flex flex-column justify-content-center">
                                <div class="row g-0">
                                    <div class="col-auto">
                                        <div class="cta-4 text-primary">
                                            {{clt_stat.today_written_count}} avis
                                        </div>
                                        <div class="text-muted small">Rédigés</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row g-2">
                    <div class="col-4">
                        <div class="h-100 row g-0 align-items-center">
                            <div class="col-auto">
                                <div class="bg-info sw-5 sh-5 rounded-md d-flex justify-content-center align-items-center">
                                    <i class="icon-20 bi-eye text-white lh-1"></i>
                                </div>
                            </div>
                            <div class="col sh-6 ps-2 d-flex flex-column justify-content-center">
                                <div class="row g-0">
                                    <div class="col-auto">
                                        <div class="cta-4 text-primary">
                                            {{clt_stat.today_published_count}} avis
                                        </div>
                                        <div class="text-muted small">Publiés</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="h-100 row g-0 align-items-center">
                            <div class="col-auto">
                                <div class="bg-danger sw-5 sh-5 rounded-md d-flex justify-content-center align-items-center">
                                    <i class="icon-20 bi-patch-exclamation text-white lh-1"></i>
                                </div>
                            </div>
                            <div class="col sh-6 ps-2 d-flex flex-column justify-content-center">
                                <div class="row g-0">
                                    <div class="col-auto">
                                        <div class="cta-4 text-primary">
                                            {{clt_stat.today_signaled_count }} avis
                                        </div>
                                        <div class="text-muted small">Signalés</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="h-100 row g-0 align-items-center">
                            <div class="col-auto">
                                <div class="bg-warning sw-5 sh-5 rounded-md d-flex justify-content-center align-items-center">
                                    <i class="icon-20 bi-question-octagon text-white lh-1"></i>
                                </div>
                            </div>
                            <div class="col sh-6 ps-2 d-flex flex-column justify-content-center">
                                <div class="row g-0">
                                    <div class="col-auto">
                                        <div class="cta-4 text-primary">
                                            {{clt_stat.today_information_needed_count}}
                                            <small>demandes</small>
                                        </div>
                                        <div class="text-muted small">d'infos</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="tab-pane fade h-100 scroll-out" id="s-days" role="tabpanel">
                <div class="row g-2" >
                    <div class="col-4">
                        <div class="h-100 row g-0 align-items-center">
                            <div class="col-auto">
                                <div class="confetti bg-success sw-5 sh-5 rounded-md d-flex justify-content-center align-items-center">
                                    <i class="icon-20 bi-inbox text-white lh-1"></i>
                                </div>
                            </div>
                            <div class="col sh-6 ps-2 d-flex flex-column justify-content-center">
                                <div class="row g-0">
                                    <div class="col-auto">
                                        <div class="cta-4 text-primary">
                                            {{clt_stat.seven_day_recived_count}} avis
                                        </div>
                                        <div class="text-muted small">Reçus</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="h-100 row g-0 align-items-center">
                            <div class="col-auto">
                                <div class="bg-alternate sw-5 sh-5 rounded-md d-flex justify-content-center align-items-center">
                                    <i class="icon-20 bi-x-octagon text-white lh-1"></i>
                                </div>
                            </div>
                            <div class="col sh-6 ps-2 d-flex flex-column justify-content-center">
                                <div class="row g-0">
                                    <div class="col-auto">
                                        <div class="cta-4 text-primary">
                                            {{clt_stat.seven_day_impossible_count}} avis
                                        </div>
                                        <div class="text-muted small">Impossible</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="h-100 row g-0 align-items-center">
                            <div class="col-auto">
                                <div class="bg-info sw-5 sh-5 rounded-md d-flex justify-content-center align-items-center">
                                    <i class="icon-20 bi-pencil text-white lh-1"></i>
                                </div>
                            </div>
                            <div class="col sh-6 ps-2 d-flex flex-column justify-content-center">
                                <div class="row g-0">
                                    <div class="col-auto">
                                        <div class="cta-4 text-primary">
                                            {{clt_stat.seven_day_written_count}} avis
                                        </div>
                                        <div class="text-muted small">Rédigés</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row g-2">
                    <div class="col-4">
                        <div class="h-100 row g-0 align-items-center">
                            <div class="col-auto">
                                <div class="bg-info sw-5 sh-5 rounded-md d-flex justify-content-center align-items-center">
                                    <i class="icon-20 bi-eye text-white lh-1"></i>
                                </div>
                            </div>
                            <div class="col sh-6 ps-2 d-flex flex-column justify-content-center">
                                <div class="row g-0">
                                    <div class="col-auto">
                                        <div class="cta-4 text-primary">
                                            {{clt_stat.seven_day_published_count}} avis
                                        </div>
                                        <div class="text-muted small">Publiés</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="h-100 row g-0 align-items-center">
                            <div class="col-auto">
                                <div class="bg-danger sw-5 sh-5 rounded-md d-flex justify-content-center align-items-center">
                                    <i class="icon-20 bi-patch-exclamation text-white lh-1"></i>
                                </div>
                            </div>
                            <div class="col sh-6 ps-2 d-flex flex-column justify-content-center">
                                <div class="row g-0">
                                    <div class="col-auto">
                                        <div class="cta-4 text-primary">
                                            {{clt_stat.seven_day_signaled_count}} avis
                                        </div>
                                        <div class="text-muted small">Signalés</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="h-100 row g-0 align-items-center">
                            <div class="col-auto">
                                <div class="bg-warning sw-5 sh-5 rounded-md d-flex justify-content-center align-items-center">
                                    <i class="icon-20 bi-question-octagon text-white lh-1"></i>
                                </div>
                            </div>
                            <div class="col sh-6 ps-2 d-flex flex-column justify-content-center">
                                <div class="row g-0">
                                    <div class="col-auto">
                                        <div class="cta-4 text-primary">
                                            {{clt_stat.seven_day_information_needed_count}}
                                            <small>demandes</small></div>
                                        <div class="text-muted small">d'infos</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="tab-pane fade h-100 scroll-out" id="t-days" role="tabpanel">
                <div class="row g-2" >
                    <div class="col-4">
                        <div class="h-100 row g-0 align-items-center">
                            <div class="col-auto">
                                <div class="confetti bg-success sw-5 sh-5 rounded-md d-flex justify-content-center align-items-center">
                                    <i class="icon-20 bi-inbox text-white lh-1"></i>
                                </div>
                            </div>
                            <div class="col sh-6 ps-2 d-flex flex-column justify-content-center">
                                <div class="row g-0">
                                    <div class="col-auto">
                                        <div class="cta-4 text-primary">
                                            {{clt_stat.thirty_day_recived_count}}  avis
                                        </div>
                                        <div class="text-muted small">Reçus</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="h-100 row g-0 align-items-center">
                            <div class="col-auto">
                                <div class="bg-alternate sw-5 sh-5 rounded-md d-flex justify-content-center align-items-center">
                                    <i class="icon-20 bi-x-octagon text-white lh-1"></i>
                                </div>
                            </div>
                            <div class="col sh-6 ps-2 d-flex flex-column justify-content-center">
                                <div class="row g-0">
                                    <div class="col-auto">
                                        <div class="cta-4 text-primary">
                                            {{clt_stat.thirty_day_impossible_count}} avis
                                        </div>
                                        <div class="text-muted small">Impossible</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="h-100 row g-0 align-items-center">
                            <div class="col-auto">
                                <div class="bg-info sw-5 sh-5 rounded-md d-flex justify-content-center align-items-center">
                                    <i class="icon-20 bi-pencil text-white lh-1"></i>
                                </div>
                            </div>
                            <div class="col sh-6 ps-2 d-flex flex-column justify-content-center">
                                <div class="row g-0">
                                    <div class="col-auto">
                                        <div class="cta-4 text-primary">
                                            {{clt_stat.thirty_day_written_count}} avis
                                        </div>
                                        <div class="text-muted small">Rédigés</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row g-2">
                    <div class="col-4">
                        <div class="h-100 row g-0 align-items-center">
                            <div class="col-auto">
                                <div class="bg-info sw-5 sh-5 rounded-md d-flex justify-content-center align-items-center">
                                    <i class="icon-20 bi-eye text-white lh-1"></i>
                                </div>
                            </div>
                            <div class="col sh-6 ps-2 d-flex flex-column justify-content-center">
                                <div class="row g-0">
                                    <div class="col-auto">
                                        <div class="cta-4 text-primary">
                                            {{clt_stat.thirty_day_published_count}} avis
                                        </div>
                                        <div class="text-muted small">Publiés</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="h-100 row g-0 align-items-center">
                            <div class="col-auto">
                                <div class="bg-danger sw-5 sh-5 rounded-md d-flex justify-content-center align-items-center">
                                    <i class="icon-20 bi-patch-exclamation text-white lh-1"></i>
                                </div>
                            </div>
                            <div class="col sh-6 ps-2 d-flex flex-column justify-content-center">
                                <div class="row g-0">
                                    <div class="col-auto">
                                        <div class="cta-4 text-primary">
                                            {{clt_stat.thirty_day_signaled_count}} avis
                                        </div>
                                        <div class="text-muted small">Signalés</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="h-100 row g-0 align-items-center">
                            <div class="col-auto">
                                <div class="bg-warning sw-5 sh-5 rounded-md d-flex justify-content-center align-items-center">
                                    <i class="icon-20 bi-question-octagon text-white lh-1"></i>
                                </div>
                            </div>
                            <div class="col sh-6 ps-2 d-flex flex-column justify-content-center">
                                <div class="row g-0">
                                    <div class="col-auto">
                                        <div class="cta-4 text-primary">
                                            {{clt_stat.thirty_day_information_needed_count}}
                                            <small>demandes</small>
                                        </div>
                                        <div class="text-muted small">d'infos</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
export default {
  name: 'ConsultantDetail',
  props: {
    consultant_uid: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      default_stat: {
        positives_count: 0,
        negatives_count: 0,
        informationneeded_count: 0,
        validated_count: 0,
        today_recived_count: 0,
        today_impossible_count: 0,
        today_written_count: 0,
        today_published_count: 0,
        today_signaled_count: 0,
        today_information_needed_count: 0,
        seven_day_recived_count: 0,
        seven_day_impossible_count: 0,
        seven_day_written_count: 0,
        seven_day_published_count: 0,
        seven_day_signaled_count: 0,
        seven_day_information_needed_count: 0,
        thirty_day_recived_count: 0,
        thirty_day_impossible_count: 0,
        thirty_day_written_count: 0,
        thirty_day_published_count: 0,
        thirty_day_signaled_count: 0,
        thirty_day_information_needed_count: 0
      }
    };
  },
  computed: {
    clt_stat() {
      if (!this.consultant_uid) return this.default_stat;
      const stats = this.$store.state.stats || [];
      return stats.find(s => s.consultant_id === this.consultant_uid) || this.default_stat;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
